
export enum BookingStatus {
	Available = 'available'
}


